import React, {Component} from 'react'
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Button,
  Heading,
  HStack,
  Text,
  VStack
} from '@chakra-ui/react';
import { useOutletContext } from "react-router-dom"

const inputStyles = {
  bg: '#FAFAF9',
  border: '1px solid',
  borderColor: '#E4E4E7',
  borderRadius: 'lg',
  _hover: { borderColor: '#A1A1AA' },
  _focus: { borderColor: '#E05252', boxShadow: '0 0 0 1px #E05252' },
};

const primaryBtn = {
  bg: '#E05252',
  color: 'white',
  size: 'lg',
  borderRadius: 'lg',
  fontWeight: '600',
  _hover: { bg: '#C94545' },
};

const secondaryBtn = {
  variant: 'outline',
  borderColor: '#E4E4E7',
  color: '#52525B',
  size: 'lg',
  borderRadius: 'lg',
  fontWeight: '500',
  _hover: { bg: '#FAFAF9', borderColor: '#A1A1AA' },
};

const AuthCard = ({ subtitle, children }) => (
  <Flex
    minH={'100vh'}
    align={'center'}
    justify={'center'}
    bg="#F5F3F0"
  >
    <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6}>
      <VStack spacing={2}>
        <HStack spacing={0}>
          <Heading fontWeight="700" fontSize="3em" color="#C94545" letterSpacing="-0.03em">Write</Heading>
          <Heading fontWeight="700" fontSize="3em" color="#E05252" letterSpacing="-0.03em">wizard</Heading>
        </HStack>
        <Text color="#A1A1AA" fontSize="lg">{subtitle}</Text>
      </VStack>
      <Box
        w='400px'
        rounded={'xl'}
        bg="white"
        boxShadow="0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)"
        p={8}
        border="1px solid"
        borderColor="#E4E4E7"
      >
        {children}
      </Box>
    </Stack>
  </Flex>
);

class SignInBoxNew extends Component {
  render() {
    return (
      <AuthCard subtitle="Welcome back">
        <Stack spacing={5}>
          <FormControl id="name">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Username</FormLabel>
            <Input
              type="name"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'username', event.target.value)}}
            />
          </FormControl>
          <FormControl id="password">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Password</FormLabel>
            <Input
              type="password"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'password', event.target.value)}}
            />
          </FormControl>
          <Button
            variant="link"
            size="sm"
            color="#A1A1AA"
            fontWeight="normal"
            alignSelf="flex-start"
            _hover={{ color: '#E05252' }}
            onClick={() => {this.props.onRouteChange('forgot_password')}}>
            Forgot Password?
          </Button>
          <Stack spacing={3} pt={2}>
            <Button {...primaryBtn} onClick={this.props.checkSignIn}>
              Sign In
            </Button>
            <Button {...secondaryBtn} onClick={() => {this.props.onRouteChange('register')}}>
              Don't Have an Account?
            </Button>
          </Stack>
        </Stack>
      </AuthCard>
    );
  }
}

class RegisterBoxNew extends Component {
  render() {
    return (
      <AuthCard subtitle="Create your account">
        <Stack spacing={5}>
          <FormControl id="name">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Username</FormLabel>
            <Input
              type="name"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'username', event.target.value)}}
            />
          </FormControl>
          <FormControl id="email">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Email</FormLabel>
            <Input
              type="email"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'email', event.target.value)}}
            />
          </FormControl>
          <FormControl id="password">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Password</FormLabel>
            <Input
              type="password"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'password', event.target.value)}}
            />
          </FormControl>
          <Stack spacing={3} pt={2}>
            <Button {...primaryBtn} onClick={this.props.onRegister}>
              Create Account
            </Button>
            <Button {...secondaryBtn} onClick={() => {this.props.onRouteChange('login')}}>
              Already Have an Account?
            </Button>
          </Stack>
        </Stack>
      </AuthCard>
    );
  }
}

class ForgotPasswordBox extends Component {
  render() {
    return (
      <AuthCard subtitle="Reset your password">
        <Stack spacing={5}>
          <FormControl id="email">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Email</FormLabel>
            <Input
              type="email"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'email', event.target.value)}}
            />
          </FormControl>
          <Stack spacing={3} pt={2}>
            <Button {...primaryBtn} onClick={this.props.onSendResetEmail}>
              Send Reset Email
            </Button>
            <Button {...secondaryBtn} onClick={() => {this.props.onRouteChange('login')}}>
              Back to Login
            </Button>
          </Stack>
        </Stack>
      </AuthCard>
    );
  }
}

class VerifyTokenBox extends Component {
  render() {
    return (
      <AuthCard subtitle="Enter your reset token">
        <Stack spacing={5}>
          <FormControl id="token">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Token</FormLabel>
            <Input
              type="text"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'token', event.target.value)}}
            />
          </FormControl>
          <Stack spacing={3} pt={2}>
            <Button {...primaryBtn} onClick={this.props.onVerifyPasswordResetToken}>
              Verify Token
            </Button>
            <Button {...secondaryBtn} onClick={() => {this.props.onRouteChange('login')}}>
              Back to Login
            </Button>
          </Stack>
        </Stack>
      </AuthCard>
    );
  }
}

class ResetPasswordBox extends Component {
  render() {
    return (
      <AuthCard subtitle="Choose a new password">
        <Stack spacing={5}>
          <FormControl id="new_pw1">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">New Password</FormLabel>
            <Input
              type="password"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'new_pw1', event.target.value)}}
            />
          </FormControl>
          <FormControl id="new_pw2">
            <FormLabel fontSize="sm" fontWeight="500" color="#52525B">Repeat New Password</FormLabel>
            <Input
              type="password"
              {...inputStyles}
              onChange={(event) => {this.props.onFormTextChange('loginDetails', 'new_pw2', event.target.value)}}
            />
          </FormControl>
          <Stack spacing={3} pt={2}>
            <Button {...primaryBtn} onClick={this.props.onResetPassword}>
              Reset Password
            </Button>
            <Button {...secondaryBtn} onClick={() => {this.props.onRouteChange('login')}}>
              Back to Login
            </Button>
          </Stack>
        </Stack>
      </AuthCard>
    );
  }
}



function Authentication ({route}) {
  const {
    onNameChange,
    onEmailChange,
    onPasswordChange,
    onRouteChange,
    onFormTextChange,
    onRegister,
    checkSignIn,
    onSendResetEmail,
    onVerifyPasswordResetToken,
    onResetPassword
  } = useOutletContext()
    return (
      <>
      {route === 'login'
        ?
      <SignInBoxNew
        onNameChange = {onNameChange}
        onPasswordChange = {onPasswordChange}
        checkSignIn = {checkSignIn}
        onRouteChange = {onRouteChange}
        onFormTextChange = {onFormTextChange}
      />
      : route === 'register'
      ?
        <RegisterBoxNew
          onNameChange = {onNameChange}
          onEmailChange = {onEmailChange}
          onPasswordChange = {onPasswordChange}
          onRegister = {onRegister}
          onRouteChange = {onRouteChange}
          onFormTextChange = {onFormTextChange}
        />
      : route === 'forgot_password'
      ?
        <ForgotPasswordBox
          onEmailChange = {onEmailChange}
          onRouteChange = {onRouteChange}
          onFormTextChange = {onFormTextChange}
          onSendResetEmail = {onSendResetEmail}
        />
      : route === 'verifyPasswordResetToken'
      ?
        <VerifyTokenBox
          onNameChange = {onNameChange}
          onEmailChange = {onEmailChange}
          onPasswordChange = {onPasswordChange}
          onRegister = {onRegister}
          onRouteChange = {onRouteChange}
          onFormTextChange = {onFormTextChange}
          onVerifyPasswordResetToken = {onVerifyPasswordResetToken}
        />
        : route === 'resetPassword'
        ?
          <ResetPasswordBox
            onNameChange = {onNameChange}
            onEmailChange = {onEmailChange}
            onPasswordChange = {onPasswordChange}
            onRegister = {onRegister}
            onRouteChange = {onRouteChange}
            onFormTextChange = {onFormTextChange}
            onResetPassword = {onResetPassword}
          />
        :
         null
      }
     </>
    )
}

export default Authentication
